'use client';

import { useLocale } from 'next-intl';
import {
    forwardRef,
    memo,
    useCallback,
    useImperativeHandle,
    useRef,
} from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { processEnv } from '../../../env.mjs';

// Cast tránh lỗi TS2786 do lệch version @types/react với type của lib
const ReCAPTCHAComponent: any = ReCAPTCHA;

const siteKey = processEnv.NEXT_PUBLIC_CAPTCHA_KEY ?? '';

export interface CaptChaProps {
    onChange?: (isValid: boolean) => void;
}

export interface CaptChaRefs {
    /**
     * Reset the captcha
     * @description This function will reset the captcha and set the isValid to false
     */
    reset: VoidFunction;
}

export const CaptCha = memo(
    forwardRef<CaptChaRefs, CaptChaProps>(({ onChange }, ref) => {
        const locale = useLocale();
        const _captchaRef = useRef<ReCAPTCHA>(null);

        const onResetCaptcha = useCallback(() => {
            if (_captchaRef.current) {
                _captchaRef.current.reset();
                onChange?.(false);
            }
        }, [onChange]);

        useImperativeHandle(ref, () => {
            return {
                reset: onResetCaptcha,
            };
        }, [onResetCaptcha]);

        if (!siteKey) {
            console.warn('Captcha key is not defined!');
            return null;
        }

        return (
            <ReCAPTCHAComponent
                ref={_captchaRef}
                sitekey={siteKey}
                onChange={(value: string | null) => {
                    if (value) {
                        onChange?.(true);
                    }
                }}
                onExpired={() => {
                    console.warn('Captcha hết hạn!');
                    onChange?.(false);
                }}
                onErrored={() => {
                    console.warn('Captcha xảy ra lỗi!');
                    onChange?.(false);
                }}
                hl={locale}
            />
        );
    })
);

CaptCha.displayName = 'CaptCha';
